import { Grid } from '@mui/material';

export const CenteredContainer = ({ ...props }) => (
  <Grid container justifyContent="center" alignItems="center" {...props} />
);
